import { Box, Typography } from '@mui/material';
import React from 'react';

interface EnrollmentBadgeProps {
  isEnrolled: boolean;
}

const EnrollmentBadge: React.FC<EnrollmentBadgeProps> = ({ isEnrolled }) => {
  const styles = isEnrolled
    ? {
        backgroundColor: '#E8F5E9',
        borderColor: '#81C784',
        color: '#2E7D32',
      }
    : {
        backgroundColor: '#FFEBEE',
        borderColor: '#E57373',
        color: '#C62828',
      };

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '8px',
        padding: '4px 12px',
        borderRadius: '20px',
        border: `1px solid ${styles.borderColor}`,
        backgroundColor: styles.backgroundColor,
      }}
    >
      <Box
        sx={{
          width: '6px',
          height: '6px',
          borderRadius: '50%',
          backgroundColor: styles.color,
        }}
      />
      <Typography
        variant="body2"
        sx={{
          color: styles.color,
          fontWeight: 500,
          fontSize: '12px',
        }}
      >
        {isEnrolled ? 'Conectado al SII' : 'No conectado al SII'}
      </Typography>
    </Box>
  );
};

export default EnrollmentBadge;
